import { useEffect, useState } from "react";
import { AdvancedFilterOptions } from "../../../Common/models/advancedFilters";
import { getProjectUsersFilterOptions } from "../api/projectDetailsHttpClient";

const emptyOptions: AdvancedFilterOptions = {
  packages: [],
  tools: [],
  projectUserRoles: [],
  modes: [],
};

export const useProjectUsersAdvancedFilters = (projectId: string) => {
  const [data, setData] = useState<AdvancedFilterOptions>(emptyOptions);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!projectId) {
      return () => undefined;
    }

    let cancelled = false;
    setIsLoading(true);

    getProjectUsersFilterOptions(projectId)
      .then((result) => {
        if (!cancelled) setData(result);
      })
      .catch(() => {
        if (!cancelled) setData(emptyOptions);
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [projectId]);

  return { data, isLoading };
};
